import { display } from '../../lib/format';
import type { ClusterMember as Member } from './queries';

/** Default survivor: most (open_deals*3 + closed_deals), tiebreak oldest add_time. */
export function computeDefaultSurvivor(members: Member[]): number | null {
  let best: Member | null = null;
  let bestScore = -Infinity;
  let bestAdd = Infinity;
  for (const m of members) {
    const score = m.openDeals * 3 + m.closedDeals;
    const add = m.addTime ? m.addTime.getTime() : Infinity;
    if (score > bestScore || (score === bestScore && add < bestAdd)) {
      best = m;
      bestScore = score;
      bestAdd = add;
    }
  }
  return best?.pdId ?? null;
}

export function renderValue(v: unknown): string {
  if (v === null || v === undefined || v === '') return '';
  return display(v);
}
